module.exports = __webpack_public_path__ + "static/media/211.918fcb53.jpg";